'use client';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { viVN } from '@mui/x-date-pickers/locales';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { vi } from 'date-fns/locale';
import { type PropsWithChildren } from 'react';

import { ReactQueryProvider } from '@/app/components/Provider/ReactQueryProvider';
import StoreProvider from '@/app/components/Provider/StoreProvider';
import ThemeProvider from '@/app/components/Provider/ThemeProvider';
import ToastProvider from '@/app/components/Provider/ToastProvider';

export const Providers = ({ children }: PropsWithChildren) => {
  return (
    <ReactQueryProvider>
      <StoreProvider>
        <ThemeProvider>
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            localeText={viVN.components.MuiLocalizationProvider.defaultProps.localeText}
            adapterLocale={vi}
          >
            <ToastProvider>{children}</ToastProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </StoreProvider>
    </ReactQueryProvider>
  );
};
